module.exports = __webpack_public_path__ + "img/slideVerify_07.f87c2cf4.png";